var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.openCamera}},[_vm._v("识别")]),_c('input',{ref:"cameraInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","capture":"environment"},on:{"change":_vm.handlePhoto}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }